import axios from "axios";

/**
 * Make an API call with the specified configuration.
 * @param {string} url - The endpoint URL.
 * @param {Object} params - Query parameters for the request.
 * @param {string} method - The HTTP method (GET, POST, PUT, DELETE).
 * @param {Object} [data] - The payload for POST/PUT requests.
 * @param {Object} [headers] - Optional headers for the request.
 * @returns {Promise} - The response data from the API.
 */
const apiCall = async ({
  url,
  params = {},
  method = "GET",
  data = null,
  headers = {},
}) => {
  try {
    const config = {
      method,
      url,
      params,
      data,
      headers: {
        'Content-Type': 'application/json',
        'x-access-token':  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVmYjU3MzI0ZjliMGUyN2RkMzVlNWY4NCIsInVzcl9pZCI6NzQ1LCJ1c3JfdHlwZSI6InN1cHBsaWVyIiwiaWF0IjoxNjMxNzY4NTAzfQ.ruPJkmWoBSDO5o1mtZWefaA-B_5tnsyb0mNILMLGug8",
        ...headers, // Add any additional headers
      },
    };

    // Execute the API call
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("API call failed:", error.message);
    throw error; // Throw the error to be handled by the caller
  }
};

export default apiCall;
